import styled from 'styled-components';


export const PartnerSolutionsSection = styled.section`
    width: 100%;

    .title-sub-page{
        margin-top: 20px;
    }
`;

export const PartnerSection = styled.section`
    width: 100%;
    background: #F1FEFF;
    padding-bottom: 50px;
    margin-top: -11px;
    .partner-section-main{
        margin-top: 10px;
    }
`;

export const SolutionWrap = styled.div`
    width: 100%;
    background: #FFFFFF;
    margin-top: -133px;
    border-radius: 20px;
    padding: 20px;
    box-shadow: 0px 20px 20px #0000000D;
    display: flex;
    flex-direction: column;
    row-gap: 20px;
`;

export const SolutionBox = styled.div`
    width: 100%;
    background: #F2F2F2;
    padding: 20px;
    border-radius: 15px;
   
`;

export const SolutionBoxTitle = styled.h3`
    width: 100%;
    color: #01606F; 
    font-size: 18px;
    font-family: 'Jost', sans-serif;
    font-weight: 500;
    line-height: 26px;
    padding-bottom: 10px;
    border-bottom: 1px solid #fff;
`;


export const SolutionBoxSpan = styled.span`
    color: #333333;
    font-size: 18px;
    font-family: 'Jost', sans-serif;
    font-weight: 400;
    line-height: 26px;
`;

export const SolutionDetailBox = styled.div`
    width: 100%;
    margin-top: 30px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    column-gap: 20px;

    @media screen and (max-width: 991px){
        flex-direction: column;
        align-items: flex-start;
        row-gap: 20px;
    }
`;

export const SolutionDetailImageWrap = styled.div`
     width: 100%;
    margin: 0 auto;

`;

export const SolutionDetailImage = styled.div`
    min-width: 195px;
    width: 100%;

    img{
        width: 100%;
        height: 100%;
        display: inline-block;
    }
`;

export const SolutionDetailTitle = styled.h4`+
    max-width: 180px;
    margin: 0 auto;
    color: #333333;
    font-size: 18px;
    font-family: 'Jost', sans-serif;
    font-weight: 700;
    line-height: 26px;
    background: #fff;
    text-align: center;
    padding: 15px 10px;
    border-radius: 0 0 10px 10px;
`;

export const SolutionDetailContent = styled.div`
    color: #333333;
    font-size: 18px;
    font-family: 'Jost', sans-serif;
    font-weight: 400;
    line-height: 26px;

    @media screen and (max-width: 575px){
        font-size: 16px;
        line-height: 24px;
    }

    strong{
        coloe:#333333;
        font-weight: 700;
    }
`;

export const ClientsListWrap = styled.div`
    width: 100%;
    margin-top: -133px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    row-gap: 20px;

    @media screen and (max-width: 767px){
        margin-top: 50px;
    }
    @media screen and (max-width: 575px){
        margin-top: 40px;
    }
`;

export const ClientsListBox = styled.div`
    width: 100%;

    .city-box-main{
        h3{
            color: #333333;
            font-size: 20px;
            font-weight: 600;
            line-height: 30px;
        }
        span{
            color: #333333;
            font-size: 18px;
            font-family: 'Jost', sans-serif;
            font-weight: 400;    
            line-height: 22px;
        }
    }
`;

export const PeopleServedBox = styled.div`
    width: 100%;
    background: transparent linear-gradient(298deg, #C69151 0%, #33B0B8 100%) 0% 0% no-repeat padding-box;
    box-shadow: 0px 10px 30px #00000014;
    border-radius: 15px;
    padding: 20px;
    color: #fff;
    font-size: 18px;
    font-family: 'Jost', sans-serif;
    font-weight: 400;
    line-height: 36px;

    @media screen and (max-width: 575px){
        font-size: 16px;
        line-height: 24px;
    }
`;

export const PeopleServedTitle = styled.h4`
    width: 100%;
    color: #FFFFFF;
    font-size: 20px;
    font-family: 'Jost', sans-serif;
    font-weight: 400;
    line-height: 30px;
    padding-bottom: 10px;
    border-bottom: 1px solid #fff;
    margin-bottom: 10px;
`;

export const PeopleServedText = styled.p`
    margin: 0px;
`;

export const FundersListBox = styled.div`
    width: 100%;

    .city-box-main{
        background: #F2F2F2;
        box-shadow: 0px 20px 20px #0000000D;

        h3{
            color: #333333;
            font-size: 20px;
            font-weight: 600;
            line-height: 30px;
            border-bottom: 1px solid #fff;

            @media screen and (max-width: 575px){
                font-size: 18px;
                line-height: 26px;
            }

        }
        
        span{
            color: #333333;
            font-size: 18px;
            font-family: 'Jost', sans-serif;
            font-weight: 400;    
            line-height: 22px;

            @media screen and (max-width: 575px){
                font-size: 16px;
                line-height: 24px;
            }
        }
    }
`; 